import { PROJECT_MEDIA_TYPES } from 'consts'
import { IVersionHistoryItem } from 'store/types/aiVideo'
import { IAIVideoProject, TAiVideoTimelineData } from 'types/aiVideo'
import { IBaseMediaItem } from 'types/media'
import { hasAiAvatarMarker } from 'utils/media'

// Avatars are stored in the same backend table as AI videos and come back through
// the ai-video API, so a fetched project is an avatar iff it carries
// `meta.aiAvatarProjectId` (see `hasAiAvatarMarker`). Used to type a selected clip
// as `aiAvatar` (so clicking it on the canvas/timeline opens the AI Avatar tab)
// instead of `aiVideo`.
export const isAvatarVideoProject = (
  video: Pick<IAIVideoProject, 'meta'>
): boolean => hasAiAvatarMarker(video.meta)

export const convertAiVideoToBaseMediaItem = (
  video?: TAiVideoTimelineData
): IBaseMediaItem => {
  if (!video) {
    throw new Error('Video data is required')
  }

  const isAvatar = isAvatarVideoProject(video)

  return {
    fileName: `${isAvatar ? 'ai-avatar' : 'ai-video'}-${video.id}.mp4`,
    type: isAvatar ? PROJECT_MEDIA_TYPES.aiAvatar : PROJECT_MEDIA_TYPES.aiVideo,
    originalWidth: video.width!,
    originalHeight: video.height!,
    path: video.videoUrl,
    previewPath: video.previewPath,
    duration: video.videoDurationSeconds,
    assetId: String(video.id),
    thumbnail: video.thumbnail,
    imageUrl: video.imageUrl
  }
}

export const convertHistoryVideoVersionToBaseMediaItem = (
  video?: IVersionHistoryItem
): IBaseMediaItem => {
  if (!video) {
    throw new Error('Video data is required')
  }

  return {
    type: PROJECT_MEDIA_TYPES.aiVideo,
    path: video.url,
    previewPath: video.previewPath,
    fileName: `ai-video-${video.id}.mp4`,
    originalWidth: video.width ?? 0,
    originalHeight: video.height ?? 0,
    duration: video.durationSeconds ?? 0,
    assetId: String(video.id),
    thumbnail: video.thumbnailUrl
  }
}
